<template>
    <Head>
        <title>Integrantes del Cabildo</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-comisiones.png');">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-7">
            <h1 class="hero-encabezado">Integrantes del Cabildo</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="bloque-general">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="encabezado-separador"><span>Conoce a los integrantes del Cabildo</span></h2>
          </div>
        </div>
        <div class="row">

          <div v-for="(item, index) in cabildo" :key="index" class="col-md-6 col-lg-4">
            <div class="tarjeta-integrante">
              <div class="tarjeta-integrante_inner">
                <img loading="lazy" width="80" height="80" :src="item.fotografia" alt="" class="tarjeta-integrante_avatar">
                <div class="tarjeta-integrante_datos">
                  <div class="tarjeta-integrante_nombre">{{ item.nombre }}</div>
                  <div class="tarjeta-integrante_puesto">{{  item.cargo }}</div>
                  <div class="tarjeta-integrante_correo">{{  item.correo }}</div>
                </div>
              </div>
              <div class="tarjeta-integrante_contacto">
                <a :href="'tel:'+item.telefono" class="tarjeta-integrante_tel">{{ item.telefono }}</a>
                <div v-if="item.extension!=''" class="tarjeta-integrante_ext">Ext. {{ item.extension }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    props:{
        cabildo: Object
    }
}
</script>
<style scoped>
.tarjeta-integrante_correo{
    font-size: .8rem;
}
.tarjeta-integrante_ext {
    padding-left: 5px;
    width: 33%;
}
.tarjeta-integrante_inner {
    align-items: flex-start !important;
}
.tarjeta-integrante_datos{
    width: 70%;
}
.tarjeta-integrante_avatar {
    height: auto;
}
</style>
